module.exports = __webpack_public_path__ + "img/fec1807.png";